<template>
    <div class="mdt-offers-upperwrap">
        <market-section title="Hotelería" :articles="articles" section-type="hotels"></market-section>
    </div>
</template>

<script>

import marketSection from '../utilities/market-section.vue';

export default {
    name: 'hotels',
    data: () => {
        return {
            articles: [
                {
                    name: 'Hotel Tropical Princess Beach Resort',
                    image: 'https://www.riuagents.com/agents/es/binaris/piscina-hotel-riu-palace-punta-cana-8_tcm92-203823.jpg',
                    category: 'La Romana',
                    price: 18200,
                    stars: 4
                },{
                    name: 'Hotel Tropical Princess Beach Resort',
                    image: 'https://www.riuagents.com/agents/es/binaris/piscina-hotel-riu-palace-punta-cana-8_tcm92-203823.jpg',
                    category: 'Samaná',
                    price: 18200,
                    stars: 4
                },{
                    name: 'Hotel Tropical Princess Beach Resort',
                    image: 'https://www.riuagents.com/agents/es/binaris/piscina-hotel-riu-palace-punta-cana-8_tcm92-203823.jpg',
                    category: 'Constanza',
                    price: 18200,
                    stars: 4
                },
                {
                    name: 'Hotel Tropical Princess Beach Resort',
                    image: 'https://www.riuagents.com/agents/es/binaris/piscina-hotel-riu-palace-punta-cana-8_tcm92-203823.jpg',
                    category: 'Punta Cana',
                    price: 18200,
                    stars: 4
                },
                {
                    name: 'Hotel Tropical Princess Beach Resort',
                    image: 'https://www.riuagents.com/agents/es/binaris/piscina-hotel-riu-palace-punta-cana-8_tcm92-203823.jpg',
                    category: 'Juan Dolio',
                    price: 18200,
                    stars: 4
                },
                {
                    name: 'Hotel Tropical Princess Beach Resort',
                    image: 'https://www.riuagents.com/agents/es/binaris/piscina-hotel-riu-palace-punta-cana-8_tcm92-203823.jpg',
                    category: 'Boca Chica',
                    price: 18200,
                    stars: 4
                },
                {
                    name: 'Hotel Tropical Princess Beach Resort',
                    image: 'https://www.riuagents.com/agents/es/binaris/piscina-hotel-riu-palace-punta-cana-8_tcm92-203823.jpg',
                    category: 'Puerto Plata',
                    price: 18200,
                    stars: 4
                },
                {
                    name: 'Hotel Marriot',
                    image: 'https://www.riuagents.com/agents/es/binaris/piscina-hotel-riu-palace-punta-cana-8_tcm92-203823.jpg',
                    category: 'Santo Domingo',
                    price: 18200,
                    stars: 5
                },
                {
                    name: 'Hotel Vegano',
                    image: 'https://www.riuagents.com/agents/es/binaris/piscina-hotel-riu-palace-punta-cana-8_tcm92-203823.jpg',
                    category: 'La Vega',
                    price: 10000,
                    stars: 2
                }
            ]
        }
    },
    components: { marketSection }
}
</script>

<style scoped>
    .mdt-offers-upperwrap {
        max-width: 1000px;
        width: 100%;
        margin: 0 auto;
    }
</style>


// WEBPACK FOOTER //
// hotel-offers.vue?7bb55faa